import React from 'react'
import {Checkbox} from 'antd'
import {FullscreenOutlined} from '@ant-design/icons'
import './index.scss'

const Overlay = ({
  label,
  selected,
  isSelectable = true,
  onChange,
}) => {
  const onCheckboxChange = (e) => onChange(e.target.checked)

  return (
    <div className="overlay">
      {isSelectable && (
        <>
          <span />
          <label>
            {label}
            <Checkbox
              checked={selected}
              onChange={onCheckboxChange}
            />
          </label>
        </>
      )}
      {!isSelectable && !!label && (
        <>{label}</>
      )}
    </div>
  )
}

const SelectablePhotoThumb = ({
  photo,
  selected,
  isSelectable = true,
  title,
  label,
  onChange,
  onClick,
}) => {
  const openFullscreen = () => onClick && onClick(photo)

  const classNames = ['selectable-photo-thumb']
  if (onClick) classNames.push('clickable')
  if (selected) classNames.push('selected')

  return (
    <div className={classNames.join(' ').trim()}>
      <div className="top">
        {typeof title === 'string'
          ? <span className="title" title={title}>{title}</span>
          : title
        }
      </div>
      <div className="content">
        <div className="photo-wrap" onClick={openFullscreen}>
          {onClick && <FullscreenOutlined />}
          <img src={photo.image.url} alt="" />
        </div>
      </div>
      {(isSelectable || !!label) && (
        <Overlay
          label={label}
          selected={selected}
          isSelectable={isSelectable}
          onChange={onChange}
        />
      )}
    </div>
  )
}

SelectablePhotoThumb.Overlay = Overlay

SelectablePhotoThumb.Wrapper = ({children}) => {
  return (
    <div className="selectable-photo-thumb-wrapper">
      {children}
    </div>
  )
}

export default SelectablePhotoThumb
